var _g, _g2, _g3, _path, _g4, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUniversityGeneralLibrary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "books",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48153",
    "data-name": "Group 48153",
    transform: "translate(0 26.689)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55352",
    "data-name": "Path 55352",
    d: "M71.754,387.288H40.8a3.659,3.659,0,0,1,0-7.319H71.754A6.139,6.139,0,0,0,71.754,387.288Z",
    transform: "translate(-34.241 -376.973)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55353",
    "data-name": "Path 55353",
    d: "M427.9,379.969h-3.219a6.139,6.139,0,0,0,0,7.319H427.9A6.139,6.139,0,0,1,427.9,379.969Z",
    transform: "translate(-390.388 -376.973)",
    fill: "#c5e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55354",
    "data-name": "Path 55354",
    d: "M38.541,354.931H6.643a6.655,6.655,0,0,1,0-13.311h31.9a1.461,1.461,0,0,1,0,2.923H6.643a3.733,3.733,0,0,0,0,7.465h31.9a1.461,1.461,0,0,1,0,2.923Z",
    transform: "translate(0 -341.62)",
    fill: "#387f75"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48154",
    "data-name": "Group 48154",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55355",
    "data-name": "Path 55355",
    d: "M71.754,45.668H40.8a3.659,3.659,0,0,1,0-7.319H71.754A6.139,6.139,0,0,0,71.754,45.668Z",
    transform: "translate(-34.241 -35.353)",
    fill: "#dff9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55356",
    "data-name": "Path 55356",
    d: "M427.9,38.349h-3.219a6.139,6.139,0,0,0,0,7.319H427.9A6.139,6.139,0,0,1,427.9,38.349Z",
    transform: "translate(-390.388 -35.353)",
    fill: "#c5e0dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55357",
    "data-name": "Path 55357",
    d: "M38.541,13.311H6.643A6.655,6.655,0,0,1,6.643,0h31.9a1.461,1.461,0,0,1,0,2.923H6.643a3.733,3.733,0,0,0,0,7.465h31.9a1.461,1.461,0,0,1,0,2.923Z",
    transform: "translate(0 0)",
    fill: "#387f75"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48155",
    "data-name": "Group 48155",
    transform: "translate(0 13.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55358",
    "data-name": "Path 55358",
    d: "M31.834,209.589H62.793a3.659,3.659,0,0,1,0,7.319H31.834a6.139,6.139,0,0,0,0-7.319Z",
    transform: "translate(-29.347 -206.593)",
    fill: "#ecfbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55359",
    "data-name": "Path 55359",
    d: "M1.459,171.24h31.9a6.655,6.655,0,0,1,0,13.311H1.459a1.461,1.461,0,0,1,0-2.923h31.9a3.733,3.733,0,0,0,0-7.465H1.459a1.461,1.461,0,0,1,0-2.923Z",
    transform: "translate(0 -171.24)",
    fill: "#63c5b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55360",
    "data-name": "Path 55360",
    d: "M388.98,171.24h-3.219a6.655,6.655,0,0,1,6.307,4.568,3.731,3.731,0,0,1,0,4.175,6.655,6.655,0,0,1-6.307,4.568h3.219a6.655,6.655,0,0,0,0-13.311Z",
    transform: "translate(-355.623 -171.24)",
    fill: "#63c5b7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_55361",
    "data-name": "Path 55361",
    d: "M316.866,256.43h5.3v12.511l-2.6-2.516-2.7,2.516Z",
    transform: "translate(-292.111 -236.396)",
    fill: "#63c5b7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_48156",
    "data-name": "Group 48156",
    transform: "translate(27.406 20.034)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55362",
    "data-name": "Path 55362",
    d: "M350.8,256.43v10.039l.046-.043,2.6,2.516V256.43Z",
    transform: "translate(-350.798 -256.43)",
    fill: "#aee0d9"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_55363",
    "data-name": "Path 55363",
    d: "M158.5,248.7H137.707a.6.6,0,0,0,0,1.207H158.5a.6.6,0,0,0,0-1.207Z",
    transform: "translate(-126.392 -229.273)",
    fill: "#aee0d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniversityGeneralLibrary);
export default __webpack_public_path__ + "static/media/university-general-library.a8e0a80a2fb28019f4bb6d7ff192bebd.svg";
export { ForwardRef as ReactComponent };